const $ = require('jquery');
const { menuBreakpoint } = require('../lib/widths');

let subNavShown = false;

// The sticky navigation menu seen on specific sub pages
function buildStickyNav() {

  // Jobin: can get rid of the cloned element on those 4th level menu items if add && ($('nav ul.menu-level-3').length > 0) to the if statement below
  if (($('body.has-sticky-nav').length > 0) && (window.innerWidth >= menuBreakpoint) && !subNavShown) {

    // Create a sticky-sub-nav placeholder element first
    $('#block-altos-child-content').prepend('<div id="sticky-sub-nav"></div>');

    // Now clone and add the parent (closest) 3rd level menu to the placeholder element
    $('a.is-active').closest('ul.menu-level-3').clone().appendTo('#sticky-sub-nav');

    subNavShown = true;

    // Set the sub nav to sticky at scroll
    // Grab the target element
    var target = $('#sticky-sub-nav');
    var position = target.offset().top;
    window.addEventListener('scroll', function () {
      var height = $(window).scrollTop();

      if (height > position) {
        target.css({'position': 'fixed', 'top': '0'});
        $('#block-altos-child-content').css('padding-top', $('#sticky-sub-nav').outerHeight() + 'px'); // prevents the "jumping" effect
      } else {
        target.css({'position': 'relative', 'top': 'auto'});
        $('#block-altos-child-content').css('padding-top', 0);
      }
    });


  }
}

// Trigger function immediately
buildStickyNav();

// Re-run as the window resizes
$(window).resize(buildStickyNav);
